/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'
import {
	disabledBlocks,
	i18n,
	srcUrl
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import DefaultImage  from  './img/img1.png'

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'

export const schema = {
	blockId: {
		type: 'string',
	},

	enableContainer: {
		type: 'boolean',
		default: true,
	},

    bannerAlignRight: {
        type: 'boolean',
        default: false,
    },

	bannerTitle: {
        type: 'string',
        default: __( 'Banner Title', i18n )
    },

    bannerLinkText: {
        type: 'string',
        default: __( 'Shop now', i18n )
    },

    bannerLinkURL: {
        type: 'string',
        default: '#'
    },

    mediaURL: {
        type: 'string',
        default: `${ srcUrl }/${ DefaultImage }`
    },

    bgColor: {
        type: 'string',
        default: 'bg-secondary'
    },

    customBgColor: {
        type: 'string',
    },

    enableImage: {
        type: 'boolean',
        default: true,
    },

	// Carousel Options
    slidesPerRow: {
        type: 'number',
        default: 3,
    },

    slidesPerRowTablet: {
        type: 'number',
        default: 2,
    },

    infinite: {
        type: 'boolean',
        default: true,
    },
}

export const name = 'czgb/banner-with-products-carousel'

export const settings = {
	title: __( 'Banner With Products Carousel', i18n ),
	icon: HeaderIcon,
	category: 'cartzillagb',
	example: {
        innerBlocks: [ { name: 'czgb/products' } ],
    },
	keywords: [
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	description: __( 'A styled banner with products carousel that you can add other blocks inside. Use this to create unique layouts.', i18n ),
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-general': true,
		'advanced-responsive': true,
		'advanced-block-spacing': true,
		'custom-css': {
			default: applyFilters( 'cartzillagb.banner-with-products-carousel.custom-css.default', '' ),
		},
	},
}